<template>
    <div class="snack-small">
        <v-snackbar
            v-model="showSnack"
            :multi-line="multiLine"
            :right="right"
            :top="top"
            :left="left"
            :bottom="bottom"
            style="margin-top: 140px;"
            :color="type"
        >
            {{ notificationMessage }}

            <template v-slot:action="{ attrs }">
                <v-btn
                v-if="showBtn"
                color="red"
                text
                v-bind="attrs"
                @click="cancel"
                >
                {{ $t('common.close') }}
                </v-btn>
            </template>
        </v-snackbar>
    </div>
</template>

<script>
export default {
 props: { 
     snackbar: Boolean, 
     multiLine: { type: Boolean, default: false },
     showBtn: { type: Boolean, default: false },
     notificationMessage: String,
     type: String,
     right: { type: Boolean, default: false },
     left: { type: Boolean, default: false },
     top: { type: Boolean, default: false },
     bottom: { type: Boolean, default: false },
     showColor: String
},
 data: function () {
    return {
      //type: 0
    }
  },
  computed: {
    showSnack:{
        get(){
            return this.snackbar;
        },
        set(val){
            this.$emit('v-snackbar', val);
            this.$emit('cancel')
        }
    }
  },
  methods:{
   cancel(){
    this.$emit('cancel')
   }
  },
  mounted() {},
  watch: {
      snackbar(val) {
        this.$emit('v-snackbar', val);
        if(!val) {
            this.$emit('cancel')  
        }
      }
  }
}
</script>

<style lang="scss">
.snack-small {
    .v-snack {
        margin-right: 25px; 
        margin-left: 25px;

        @media screen and (max-width: 599px) {
            margin-right: 5px; 
            margin-left: 5px;  
            max-width: calc(100% - 10px);
            min-width: 0px;
            .v-snack__wrapper {
                max-width: 100%;
                min-width: 0px;
            }
        }

        z-index: 1000 !important;
    }
    
}
</style>
